<template>
  <LpTag
    size="medium"
    :class="[
      'bubble text-sm items-baseline',
      sign,
      color
    ]"
  >
    <div class="flex items-baseline gap-1">
      <ArrowRightIcon
        v-if="sign!=='none'"
        class="w-3 h-3 arrow-icon"
      />
      <span class="block m-0"> {{ formattedDiff || '-' }} </span>
    </div>
  </LpTag>
</template>

<script>
import { computed } from 'vue';

import { ArrowRightIcon } from '@thehotelsnetwork/icons/vue/linear';

export default {
  components: {
    ArrowRightIcon,
  },
  props: {
    diff: {
      type: Number,
      default: 0,
    },
    formattedDiff: {
      type: String,
      default: '',
    },
    allowColors: {
      type: Boolean,
    },
    inverse: {
      type: Boolean,
    },
  },

  setup(props) {
    const getSign = (num = 0) => {
      if (num === 0) {
        return 'none';
      }
      return num > 0 ? 'positive' : 'negative';
    };

    const sign = computed(() => getSign(props.diff));

    const color = computed(() => {
      if (sign.value === 'none' || !props.allowColors) {
        return 'gray';
      }
      if (sign.value === 'positive') {
        return props.inverse ? 'red' : 'green';
      }
      if (sign.value === 'negative') {
        return props.inverse ? 'green' : 'red';
      }
      return 'gray';
    });

    return {
      getSign,
      sign,
      color,
    };
  },
};
</script>

<style lang="postcss" scoped>
.bubble.gray {
  @apply bg-base-400 bg-opacity-30 text-base-700;
}
.bubble.green {
  @apply bg-success-300 bg-opacity-50;
}
.bubble.red {
  @apply bg-danger-300;
}
.symbol {
  @apply text-base leading-1 block text-base-700;
}
.negative .arrow-icon {
  @apply transform origin-center rotate-90;
}
.positive .arrow-icon {
  @apply transform origin-center -rotate-90;
}
</style>
